import React, { useState, useEffect } from "react";
import { Box, Stack } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useParams } from "react-router-dom"; // 👈 Route parameter
// Components
import ChatSidebar from "./ChatSidebar";
import ChatHeader from "./ChatHeader";
import ChatContent from "./ChatContent";
import ChatDrawer from "./ChatDrawer";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import useTokenExpiryCheck from "../../utils/UseTokenExpiryCheck";

export default function CommunicationPage() {
  const theme = useTheme();
  const { groupId } = useParams(); // Access groupId from route params
 
  console.log(groupId); // You should see the groupId value here

  const [selectedChat, setSelectedChat] = useState(null); // ⬅️ initialized to null instead of false
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [sidebarType, setSidebarType] = useState("CONTACT");
  useTokenExpiryCheck();
 
  return (
    <Stack direction="row" sx={{ width: "100%", height: "100vh" }}>
      {/* Toast Notification */}
      <ToastContainer position="top-right" autoClose={3000} />

      {/* Left Sidebar */}
      <Box
        sx={{
          width: {
            xs: "100%", // full width on extra-small devices (mobile)
            sm: 280, // narrower on small screens
            md: 320, // medium width on tablets
            lg: 360, // larger on desktops
            xl: 400, // maximum width on wide screens
          },
          borderRight: "1px solid",
          borderColor: theme.palette.divider,
          backgroundColor:
            theme.palette.mode === "light"
              ? "rgba(255, 255, 255, 0.9)"
              : theme.palette.background.paper,
          backdropFilter: "blur(8px)",
          transition: "all 0.3s ease-in-out",
        }}
      >
        <ChatSidebar
          setSelectedChat={setSelectedChat}
          setDrawerVisible={setDrawerVisible}
          setSidebarType={setSidebarType}
          setSidebarOpen={setSidebarOpen}
        />
      </Box>

      {/* Main Chat Window */}
      <Box
        sx={{
          width: sidebarOpen ? "calc(100vw - 740px)" : "calc(100vw - 420px)",
          backgroundColor:
            theme.palette.mode === "light"
              ? "#F0F4FA"
              : theme.palette.background.default,
          display: "flex",
          flexDirection: "column",
          transition: "all 0.3s ease-in-out",
        }}
      >
        {/* Chat Header */}
        <Box
          sx={{
            px: 3,
            py: 2,
            backgroundColor: "#fff",
            borderBottom: "1px solid",
            borderColor: theme.palette.divider,
            boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
          }}
        >
          <ChatHeader selectedChat={selectedChat} />
        </Box>

        {/* Message Area */}
        <Box sx={{ flex: 1, overflowY: "auto", p: { xs: 2, sm: 3 } }}>
          <ChatContent selectedChat={selectedChat} groupId={groupId} />
        </Box>
      </Box>

      {/* Right Sidebar (Future: Group Info / Members) */}
      {sidebarOpen && (
        <Box
          sx={{
            width: 320,
            borderLeft: "1px solid",
            borderColor: theme.palette.divider,
            backgroundColor:
              theme.palette.mode === "light"
                ? "rgba(255, 255, 255, 0.95)"
                : theme.palette.background.paper,
            height: "100%",
            overflowY: "auto",
            backdropFilter: "blur(8px)",
            transition: "all 0.3s ease-in-out",
          }}
        >
          {/* Future content for right sidebar */}
        </Box>
      )}

      {/* Chat Action Drawer */}
      <ChatDrawer
        visible={drawerVisible}
        onClose={() => setDrawerVisible(false)}
      />
    </Stack>
  );
}
